import {
  ResponsiveContainer, LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend,
} from "recharts";

const fmtGBP = (v) =>
  new Intl.NumberFormat("en-GB", { notation: "compact", maximumFractionDigits: 1 }).format(v || 0);

/**
 * Loss-exceedance curve. `series` = [{ name, color, points: [{loss, probability}] }].
 * Curves share the same sampled probability grid, so we pivot on exceedance probability:
 * X = probability the annual loss is exceeded, Y = loss (£) at that probability.
 */
export const ExceedanceCurve = ({ series = [], height = 280 }) => {
  const valid = series.filter((s) => s.points?.length);
  if (!valid.length) return null;
  const n = valid[0].points.length;
  const data = Array.from({ length: n }, (_, i) => {
    const row = { exceedance: Math.round(valid[0].points[i].probability * 100) };
    valid.forEach((s) => { row[s.name] = Math.round(s.points[i]?.loss || 0); });
    return row;
  }).sort((a, b) => a.exceedance - b.exceedance);

  return (
    <div data-testid="exceedance-curve" style={{ width: "100%", height }}>
      <ResponsiveContainer>
        <LineChart data={data} margin={{ top: 10, right: 16, left: 4, bottom: 18 }}>
          <CartesianGrid strokeDasharray="3 3" stroke="#00000010" />
          <XAxis
            dataKey="exceedance" type="number" domain={[0, 100]}
            tick={{ fontSize: 11, fill: "#6b6b78" }}
            tickFormatter={(v) => `${v}%`}
            label={{ value: "Probability of exceedance", position: "insideBottom", offset: -8, fontSize: 11, fill: "#9a9aa6" }}
          />
          <YAxis
            tick={{ fontSize: 11, fill: "#6b6b78" }}
            tickFormatter={(v) => `£${fmtGBP(v)}`}
            width={64}
          />
          <Tooltip
            formatter={(v, name) => [`£${(v || 0).toLocaleString("en-GB")}`, name]}
            labelFormatter={(l) => `${l}% chance annual loss exceeds`}
            contentStyle={{ fontSize: 12, borderRadius: 8, border: "1px solid #00000012" }}
          />
          <Legend wrapperStyle={{ fontSize: 11, paddingTop: 6 }} iconSize={10} iconType="plainline" />
          {valid.map((s) => (
            <Line key={s.name} type="monotone" dataKey={s.name} stroke={s.color}
                  strokeWidth={2.5} dot={false} activeDot={{ r: 4 }} />
          ))}
        </LineChart>
      </ResponsiveContainer>
    </div>
  );
};
